import { NumberField } from '../types'

export function convertNumberToPercentage(value: number) {
  return value === undefined ? null : Math.round(value * 100)
}

export function convertToPercentage(field: NumberField) {
  return {
    min: convertNumberToPercentage(field.min),
    max: convertNumberToPercentage(field.max),
    value: convertNumberToPercentage(field.value)
  }
}

export function convertToFixedPercentage(decimalValue: number, decimalPlaces: number) {
  return decimalValue && !Number.isNaN(decimalValue)
    ? `${(decimalValue * 100).toFixed(decimalPlaces)} %`
    : '0 %'
}

export function convertFromPercentage(field: NumberField) {
  return {
    min: field.min / 100,
    max: field.max / 100,
    value: field.value / 100
  }
}
